export default "__VITE_ASSET__117a0008__"